
import React, { useState } from 'react';
import axios from 'axios';
import {
    List,
    ListItem,
    ListItemText,
    ListItemSecondaryAction,
    IconButton,
} from "@material-ui/core";
import { Delete as DeleteIcon, Add as AddIcon, FormatListBulleted } from "@material-ui/icons";
// models
import { Collaborator, Message, MessageTypes } from '../../../../entities/site';
import { User } from '../../../../entities/user';
// components
import TextInput from '../../../../components/inputs/TextInput';
// services
import AuthService from '../../../../services/auth';
// containter
import Loader from '../../../../containers/Loader';
import Modal from '../../../../containers/Modal';

interface EditCollaboratorProps {
    open: boolean;
    campaignId: string;
    collaborators: Collaborator[];
    onClose(): void;
    onDelete(collaborator: Collaborator): void;
    onAdd(collaborator: Collaborator): void;
}

const EditCollaborators: React.FC<EditCollaboratorProps> = (props) => {

    const [loading, setLoading] = useState<boolean>(false);
    const [message, setMessage] = useState<Message>({ message: '', messageType: MessageTypes.notification });
    const [term, setTerm] = useState<string>('');
    const [users, setUsers] = useState<User[]>([]);

    const fetchUsers = async (termSearch: string) => {
        const usersRes = await axios.post(`${AuthService.getApiUrls().user}/users/_search`, {
            "query": {
                "multi_match": {
                    "query": termSearch,
                    "type": "phrase_prefix",
                    "fields": ["name", "email"]
                }
            }
        });
        setUsers(usersRes.data.results);
    }

    const handleSearch = (termSearch: string) => {
        setTerm(termSearch);
        if (termSearch.length > 2) {
            fetchUsers(termSearch);
        }
        if (termSearch.length === 0) {
            setUsers([]);
        }
    }

    const handleAddUser = async (user: User) => {
        const newCollaborator: Collaborator = {
            id: user.userId,
            userId: user.userId,
            campaignId: props.campaignId,
            name: user.name,
            type: 'individual'
        }
        props.onAdd(newCollaborator);
        setTerm('');
        setUsers([]);
    }

    return (
        <Modal
            open={props.open}
            title="Edit Collaborators"
            onClose={props.onClose}
            message={message}
        >
            <Loader open={loading}>
                <div>Add New</div>
                <div>
                    <TextInput
                        title=""
                        type="string"
                        placeholder="Search users"
                        result={term}
                        onChange={(event: any) => handleSearch(event.target.value)}
                    />
                </div>
                <div>
                    {users.map((user: User, index) => (
                        <div key={`user-${index}`} style={{ display: 'flex', justifyContent: 'space-between' }}>
                            <div>
                                <div>{user.name} - {user.email}</div>
                                <div style={{ fontSize: 10 }}>{user.userId}</div>
                            </div>
                            <AddIcon onClick={() => handleAddUser(user)} />
                        </div>
                    ))}
                </div>
                <List>
                    {props.collaborators.map((collaborator, index) => (
                        <ListItem divider key={`team-${index}`}>
                            <ListItemText
                                primary={`${(collaborator.name ? collaborator.name : collaborator.userId)}`}
                                secondary={`${(collaborator.name ? collaborator.userId : '')}`}
                            />
                            <ListItemSecondaryAction>
                                <IconButton
                                    edge="end"
                                    aria-label="delete"
                                    onClick={() => props.onDelete(collaborator)}
                                >
                                    <DeleteIcon />
                                </IconButton>
                            </ListItemSecondaryAction>
                        </ListItem>
                    ))}
                </List>
            </Loader>
        </Modal>
    );
};

export default EditCollaborators;


// WEBPACK FOOTER //
// ./src/pages/admin/campaign/components/EditCollaborators.tsx